import { loadFacilityOptions, SelectOption } from '@api/loadOptions'
import { appointmentModes, appointmentTypes } from '@data'
import { useAppointment } from '@hook'
import { DateInputField, TextAreaField } from '@ui'
import { Select } from '@ui/SearchInput/Select'
import moment from 'moment'
import { useEffect, useMemo } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { BookAppointmentForm } from './BookAppointmentTypes'

export const BookAppointmentStepDetails = () => {
  const { control, setValue, watch } = useFormContext<BookAppointmentForm>()
  const facility = watch('facility')
  const date = watch('date')
  console.log(date)
  const appointmentDateKey = useMemo(() => (date ? moment(date).format('YYYY-MM-DD') : ''), [date])
  console.log(appointmentDateKey)

  useEffect(() => {
    setValue('doctor', '', { shouldDirty: false, shouldValidate: false })
    setValue('doctorName', '', { shouldDirty: false, shouldValidate: false })
  }, [facility, appointmentDateKey, setValue])

  const { availableDoctors } = useAppointment({
    facility_id: facility,
    appointment_at: date ? moment(date).format('YYYY-MM-DD') : undefined
  })

  const doctorsOptions = useMemo(() => {
    return (
      availableDoctors?.map(doctor => ({
        label: [doctor.attributes.first_name, doctor.attributes.last_name].filter(Boolean).join(' ').trim() || '—',
        value: doctor.id
      })) ?? []
    )
  }, [availableDoctors])

  return (
    <div className="flex flex-col gap-4">
      <Controller
        control={control}
        name="facility"
        render={({ field: { onChange } }) => (
          <Select
            borderRadius={'100px'}
            defaultOptions
            getOptionLabel={(option: SelectOption) => option.label}
            isAsync
            label="Facility"
            loadOptions={loadFacilityOptions}
            name="facility"
            onChange={(newValue: any) => {
              onChange(newValue)
              setValue('facility', newValue?.value)
              setValue('facilityName', newValue?.label)
            }}
            placeholder="Select a facility"
          />
        )}
      />
      <DateInputField dateFormat="dd MMM, yyyy" label="Date" name="date" placeholder="Select date" />
      <Controller
        control={control}
        name="doctor"
        render={({ field: { onChange } }) => (
          <Select
            borderRadius={'100px'}
            getOptionLabel={(option: SelectOption) => option.label}
            getOptionValue={(option: SelectOption) => option.value}
            label="Doctor"
            name="doctor"
            onChange={(newValue: any) => {
              onChange(newValue?.value)
              setValue('doctorName', newValue?.label)
            }}
            options={doctorsOptions}
            placeholder="Select a doctor"
            value={doctorsOptions.find(({ value }) => value === watch('doctor'))}
          />
        )}
      />
      <Controller
        control={control}
        name="appointmentType"
        render={({ field: { onChange } }) => (
          <Select
            borderRadius={'100px'}
            label="Appointment type"
            name="appointmentType"
            onChange={(newValue: any) => {
              onChange(newValue?.value)
            }}
            options={appointmentTypes}
            placeholder="Select appointment type"
            value={appointmentTypes.find(({ value }) => value === watch('appointmentType'))}
          />
        )}
      />

      <Controller
        control={control}
        name="appointmentMode"
        render={({ field: { onChange } }) => (
          <Select
            borderRadius={'100px'}
            label="Appointment mode"
            name="appointmentMode"
            onChange={(newValue: any) => onChange(newValue?.value)}
            options={appointmentModes}
            placeholder="Select appointment mode"
            value={appointmentModes.find(({ value }) => value === watch('appointmentMode'))}
          />
        )}
      />
      <TextAreaField
        className="border border-[#ECECEC]"
        label="Reason for visit"
        name="reason"
        placeholder="Describe your symptoms or reason for visit"
        style={{ minHeight: '100px' }}
      />
    </div>
  )
}
